var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCartSolid = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  viewBox: "7 9 16 13"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M22.369 19H12.225l-.159-1-.158-1h9.759a.5.5 0 0 0 .493-.418l.833-5A.498.498 0 0 0 22.5 11H10.958l-.25-1.578A.5.5 0 0 0 10.215 9H7.5a.5.5 0 1 0 0 1h2.287l1.448 9.145A1.498 1.498 0 0 0 11.869 22c.827 0 1.5-.673 1.5-1.5 0-.177-.036-.343-.092-.5h5.684a1.5 1.5 0 0 0-.092.5c0 .827.673 1.5 1.5 1.5s1.5-.673 1.5-1.5c0-.177-.036-.343-.092-.5h.592a.5.5 0 0 0 0-1"
})));
export default SvgCartSolid;